import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import { MakeDBComponent } from '../components/makeComponents';
import clsx from 'clsx';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Helmet from '../components/Helmet';
import CircleBrands from '../assets/images/circle-brands.png';
import CircleTop from '../assets/images/circle-top.png';
import CurveTop from '../assets/images/topcurva.png';
import ItemProduct from '../components/makeComponents/components/ItemProduct';
import api from '../services/api';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Divider, Skeleton } from 'antd';
import { getPicture } from '../modules/imageHandler';
import { Navigation, Autoplay, Pagination } from 'swiper';
import moment from 'moment';
import { CardCounterBanner } from '../util/cardCounterBanner';

const useStylesHeadItem = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRight: '2px solid #e30a17',
    paddingRight: '20px',
    marginRight: '10px',
    '&:last-child': {
      border: 'none',
    },
  },
  rootMobil: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  logo: {
    width: 50,
  },
  logoContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 80,
    height: 76,
  },
  title: {
    fontWeight: 600,
  },
  textCenter: {
    textAlign: 'center',
  },
  subtitle: {
    fontWeight: 400,
  },
}));

function HeadItem({ icon, title, subtitle }) {
  const isMobil = useMediaQuery('(max-width:1079px)');
  const classes = useStylesHeadItem();

  return (
    <div className={clsx({ [classes.root]: !isMobil, [classes.rootMobil]: isMobil })}>
      <div className={classes.logoContent}>
        <img className={classes.logo} src={require(`../../public/icons/${icon}`)} alt="" />
      </div>
      <div>
        <Typography className={clsx(classes.title, { [classes.textCenter]: isMobil })}>{title}</Typography>
        <Typography className={clsx(classes.subtitle, { [classes.textCenter]: isMobil })}>{subtitle}</Typography>
      </div>
    </div>
  );
}

const useStylesHeadSection = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1, 0, 3, 0),
  },
  title: {
    display: 'block',
    marginBottom: theme.spacing(3),
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'left',
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  listItemMobil: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: theme.spacing(2),
    gridAutoRows: 'minmax(100px, auto)',
  },
  newProducts: {
    '& .swiper-slide > div::before': {
      content: '"nuevo"',
      background: '#782CBD',
      color: 'white',
      borderRadius: 3,
      position: 'absolute',
      textTransform: 'uppercase',
      padding: '4px 8px',
      zIndex: '9999',
      left: 2,
      '@media (min-width:601px)': {
        top: 0,
      },
      '@media (max-width:600px)': {
        bottom: 135,
      },
    },
  },
}));

function HeadSection() {
  const isMobil = useMediaQuery('(max-width:1079px)');
  const classes = useStylesHeadSection();
  return (
    <section className={classes.root}>
      <Typography className={classes.title}>Disponibilidad y entregas a nivel nacional</Typography>
      <div
        className={clsx({
          [classes.listItem]: !isMobil,
          [classes.listItemMobil]: isMobil,
        })}
      >
        <HeadItem icon={'mensajero.svg'} title={'Entregas a nivel nacional'} subtitle={'Cobertura en toda Colombia'} />
        <HeadItem icon={'consultante.svg'} title={'Asesoría en venta'} subtitle={'Telefónica y WhatsApp'} />
        <HeadItem icon={'certificado-de-garantia.svg'} title={'Garantía directa'} subtitle={'Con fácil tratamiento'} />
        <HeadItem icon={'online-store.svg'} title={'Compra como prefieras'} subtitle={'Online o llamándonos'} />
      </div>
    </section>
  );
}

function Home() {
  const classes = useStylesHeadSection();
  const isMobil = useMediaQuery('(max-width:1079px)');
  const [productsMostSales, setProductsMostSales] = React.useState();
  const [bannersSales, setBannersSales] = React.useState([]);

  console.log('bannersSales', bannersSales);

  React.useEffect(() => {
    const fetchDataSales = async () => {
      const { data } = await api.products.find({
        query: { $client: { sales: 'true' } },
      });
      setProductsMostSales(data);
    };
    fetchDataSales();
  }, []);

  React.useEffect(() => {
    const fetchDataBannersSales = async () => {
      const { data } = await api.banners.find({
        query: {
          type: 'FLASH_SALE',
          $sort: { createdAt: -1 },
          $and: [
            { start_date: { $lte: moment().utc().format('YYYY-MM-DD') } },
            { end_date: { $gte: moment().utc().format('YYYY-MM-DD') } },
          ],
        },
      });
      setBannersSales(data);
    };
    fetchDataBannersSales();
  }, []);

  return (
    <>
      <Helmet
        description="Más de 4500 productos con un solo proveedor y en una sola factura"
        og={{
          url: window.location.href,
          title: 'Estrategias LTDA',
          description: 'Más de 4500 productos con un solo proveedor y en una sola factura',
          image: '',
        }}
      />
      {!productsMostSales || (productsMostSales && productsMostSales.length == 0) ? (
        <>
          <Skeleton.Image active={true} style={{ width: '100vw', height: 500 }} />
          <Divider />
        </>
      ) : (
        <MakeDBComponent code={'HOME_TOP_BANNER'} />
      )}

      {!productsMostSales || (productsMostSales && productsMostSales.length <= 0) ? (
        <>
          <Skeleton.Image active={true} style={{ width: '100vw', height: 500 }} />
          <Divider />
        </>
      ) : (
        <MakeDBComponent code={'HOME_BANNERS_PROMO'} />
      )}

      <div style={{ position: 'relative', paddingBottom: 60, paddingTop: 60 }}>
        <Container style={{ zIndex: 1, position: 'relative' }}>
          <Grid item xs={12}>
            {bannersSales?.length > 0 && (
              <div className="swiper-wrapper-custom" style={{ position: 'relative', marginBottom: 40 }}>
                <div className="promoTitl">
                  <div>
                    {/* <img src="/img/promo.png" /> */}
                    <Typography className={classes.title} style={{ marginLeft: 10 }}>
                      Flash Sale
                    </Typography>
                  </div>
                </div>
                <Swiper
                  key={isMobil ? 'banner-mobil' : 'banner'}
                  autoplay={{
                    delay: 2500,
                    // disableOnInteraction: true,
                  }}
                  breakpoints={{
                    600: {
                      slidesPerView: 3,
                    },
                    1024: {
                      slidesPerView: bannersSales.length > 2 ? 3 : 2,
                    },
                  }}
                  modules={[Autoplay, Navigation, Pagination]}
                  navigation={false}
                  pagination={false}
                  spaceBetween={20}
                  className={bannersSales.length == 1 ? 'swiper-custom' : ''}
                >
                  {bannersSales?.map((it, i) => (
                    <SwiperSlide key={i}>
                      <div style={{ width: '100%', cursor: 'pointer' }}>
                        {it?.end_date && <CardCounterBanner key={it?.id} item={it} />}
                        <div
                          className="banner-flash-sale"
                          onClick={() => {
                            window.location.href = it.url;
                          }}
                        >
                          <div>
                            <img
                              alt={it.title || 'banner'}
                              src={getPicture(it?.path_desktop, 1000, 500)}
                              style={{ width: '100%', height: 'auto' }}
                            />
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            )}
          </Grid>

          <Grid container spacing={3}>
            {!productsMostSales || (productsMostSales && productsMostSales.length <= 0) ? (
              <>
                <Skeleton.Image active={true} style={{ width: '100vw', height: 500 }} />
                <Divider />
              </>
            ) : (
              <Grid item xs={12}>
                <MakeDBComponent code={'HOME_SALE_PRODUCTS'} />
              </Grid>
            )}

            {!!productsMostSales ? (
              <Typography className={classes.title} style={{ marginLeft: 10 }}>
                Los más vendidos
              </Typography>
            ) : (
              <Skeleton.Input active={true} style={{ width: 200, height: 60 }} />
            )}
            <Swiper spaceBetween={14} slidesPerView={isMobil ? 2 : 4}>
              {!!productsMostSales ? (
                productsMostSales.map((it) => (
                  <SwiperSlide key={it.id}>
                    <ItemProduct data={it} />
                  </SwiperSlide>
                ))
              ) : (
                <Skeleton.Image active={true} style={{ width: 500, height: 400 }} />
              )}
            </Swiper>

            {!productsMostSales || (productsMostSales && productsMostSales.length <= 0) ? (
              <>
                <Skeleton.Image active={true} style={{ width: '100vw', height: 500 }} />
                <Divider />
              </>
            ) : (
              <Grid item xs={12} className={classes.newProducts}>
                <MakeDBComponent code={'HOME_NEW_PRODUCTS'} />
              </Grid>
            )}

            {!productsMostSales || (productsMostSales && productsMostSales.length <= 0) ? (
              <>
                <Skeleton.Image active={true} style={{ width: '100vw', height: 500 }} />
                <Divider />
              </>
            ) : (
              <Grid item xs={12} style={{ marginBottom: 40 }}>
                <MakeDBComponent code={'HOME_CATEGORIES'} />
              </Grid>
            )}

            <Grid item xs={12}>
              <HeadSection />
            </Grid>
            {!productsMostSales || (productsMostSales && productsMostSales.length <= 0) ? (
              <>
                <Skeleton.Image active={true} style={{ width: '100vw', height: 500 }} />
                <Divider />
              </>
            ) : (
              <Grid item xs={12}>
                <MakeDBComponent code={'HOME_BRANDS'} />
              </Grid>
            )}
          </Grid>
          {/* <Box mb={10} /> */}
        </Container>
        <img
          alt=""
          style={{ position: 'absolute', bottom: 0, right: 0, zIndex: 0, maxWidth: '35%' }}
          src={CircleBrands}
        />
        <img alt="" style={{ position: 'absolute', top: 0, left: 0, zIndex: 0, maxWidth: '35%' }} src={CircleTop} />
        <img alt="" style={{ position: 'absolute', top: '16%', right: 0, zIndex: 0, maxWidth: '35%' }} src={CurveTop} />
        <img
          alt=""
          style={{ position: 'absolute', top: '60%', left: 0, zIndex: 0, maxWidth: '35%', transform: 'rotateY(180deg)' }}
          src={CurveTop}
        />
      </div>
    </>
  );
}

export default Home;
